<template>
  <div class="step-list-container" :class="{'open-child': selectedDomain}">
    <div v-if="selectedDomain.sid !== 'none'" class="search-input">
      <input type="text" v-model="searchPathText" :placeholder="$t('firstPath.searchDefault')" @input="searchPath">
      <i class="icon icon--search size-12"></i>
    </div>
    <div class="base-step-list step-list">
      <div class="step-list-header">
        <div class="step-checkbox">
          <div class="checkbox-wrap" :style="{ marginLeft: '5px' }" @click.stop="toggleAllDomain()">
            <div class="checkbox" :class="domainListState"></div>
          </div>
        </div>
        <div class="step-title">{{ $t('common.domain') }}</div>
        <div class="step-badge">
          <span class="brand-mark">{{ checkedDomainLength | thousand }}</span>/{{ domainList.length | thousand }}
        </div>
        <div class="step-sort-btn" :class="domainSort" @click="sortDomain()">
          <i class="icon icon--sort-asc"></i>
          <i class="icon icon--sort-desc"></i>
        </div>
      </div>
      <div class="step-list-body" :class="{onSelect: selectedDomain.sid !== 'none'}">
        <div class="step-item-row" v-for="domain in domainList" :key="domain.sid" @click="selectDomain(domain)" :class="{selected: selectedDomain && domain.sid === selectedDomain.sid}">
          <div class="step-item">
            <div class="step-checkbox">
              <div class="checkbox-wrap" @click.stop="toggleDomain(domain)">
                <div class="checkbox" :class="domain.isShare ? 'on' : 'off'"></div>
              </div>
            </div>
            <div class="step-title ellipsis">{{ domain.domain }}</div>
            <div class="step-button" v-if="domain.firstPathList.length > 0">
              <i v-if="selectedDomain && domain.sid === selectedDomain.sid" class="icon icon--arrow-body-right-red size-20"></i>
              <i v-else class="icon icon--arrow-body-right-gray size-20"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template>
      <div class="children-step-list step-list">
        <div class="step-list-header">
          <div class="step-checkbox">
            <div class="checkbox-wrap" @click="toggleAllPath()">
              <div class="checkbox" :class="[pathListState, {disabled: searchedPathList.length === 0 }]"></div>
            </div>
          </div>
          <div class="step-title">{{ $t('common.firstPath') }}</div>
          <div class="step-badge" v-if="selectedDomain.sid === 'none'">
            <span class="brand-mark" >0</span>/ 0
          </div>
          <div class="step-badge" v-else>
            <span class="brand-mark">{{ sharedDomains[selectedDomain.sid].length | thousand }}</span>/{{ searchedPathList.length | thousand }}
          </div>
          <div class="step-tooltip-button">
            <i class="icon icon--info-outline-white" v-btf-tooltip:top="$t('share.shareList.firstPath.tooltipText')"></i>
          </div>
          <div class="step-sort-btn" :class="[pathSort, {disabled: searchedPathList.length <= 1}]" @click="sortPath()">
            <i class="icon icon--sort-asc"></i>
            <i class="icon icon--sort-desc"></i>
          </div>
        </div>
        <div class="step-list-body">
          <template v-if="selectedDomain.sid === 'none'">
            <div class="no-item">
              <div class="no-item-message">{{ $t('share.shareList.noSelected') }}</div>
            </div>
          </template>
          <template v-else-if="searchPathText && searchedPathList.length === 0">
            <div class="no-item">
              <i class="icon--empty"></i>
              <div class="no-item-message">{{ $t('share.shareList.noSearch') }}</div>
            </div>
          </template>
          <template v-else-if="selectedDomain.firstPathList.length === 0">
            <div class="no-item">
              <i class="icon--empty"></i>
              <div class="no-item-message">{{ $t('share.shareList.noItem') }}</div>
            </div>
          </template>
          <template v-else>
            <div class="step-item-row" v-for="path in searchedPathList" :key="`path-${path}-${checkSelectPath(path)}`" @click="toggleFirstPath(path)">
              <div class="step-item">
                <div class="step-checkbox">
                  <div class="checkbox-wrap">
                    <div class="checkbox" :class="{on: checkSelectPath(path) > -1}"></div>
                  </div>
                </div>
                <div v-if="!!path" class="step-title path-name" v-html="matchedText(path)"></div>
                <div v-else class="step-title path-name-none" v-html="matchedText(path)"></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'StepDataList',
  props: {
    domains: {
      type: Array,
      default: null
    },
    selectedList: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      domainList: [],
      selectedDomain: null,
      sharedDomains: {},
      selectedPathList: [],
      domainSort: 'asc',
      pathSort: '',
      searchPathText: '',
      searchPathList: []
    }
  },
  computed: {
    checkedDomainLength () {
      return this.domainList.filter(item => item.isShare).length
    },
    domainListState () {
      return this.checkedDomainLength === 0 ? 'off' : this.checkedDomainLength === this.domainList.length ? 'on' : 'set'
    },
    pathListState () {
      const orgLength = this.searchedPathList.length
      return this.selectedPathList.length === 0 || orgLength === 0 ? 'off' : orgLength === this.selectedPathList.length ? 'on' : 'set'
    },
    searchedPathList () {
      if (!this.selectedDomain) return []
      return this.searchPathText ? this.searchPathList : this.selectedDomain.firstPathList
    }
  },
  watch: {
    domains () {
      this.domainList = this.domains
      if (this.selectedList) {
        this.domainList.forEach(item => {
          item.isShare = false
          if (this.selectedList[item.domain]) {
            item.isShare = true
            this.sharedDomains[item.sid] = [...this.selectedList[item.domain]]
          } else {
            this.sharedDomains[item.sid] = []
          }
        })
      } else {
        this.domainList.forEach(item => {
          this.sharedDomains[item.sid] = [...item.firstPathList]
        })
        this.updateSharedDomain()
      }
      // this.selectDomain(this.domainList[0])
    },
    selectedPathList (value) {
    }
  },
  created () {
    this.selectedDomain = {
      sid: 'none',
      firstPathList: []
    }
  },
  mounted () {
    this.domainList = this.domains
    if (this.selectedList) {
      this.domainList.forEach(item => {
        item.isShare = false
        if (this.selectedList[item.domain]) {
          item.isShare = true
          this.sharedDomains[item.sid] = [...this.selectedList[item.domain]]
        } else {
          this.sharedDomains[item.sid] = []
        }
      })
    } else {
      this.domainList.forEach(item => {
        this.sharedDomains[item.sid] = [...item.firstPathList]
      })
      this.updateSharedDomain()
    }
  },
  methods: {
    updateSharedDomain () {
      this.$emit('update', this.sharedDomains)
    },
    sortDomain () {
      this.domainSort = !this.domainSort ? 'asc' : this.domainSort === 'asc' ? 'desc' : 'asc'
      this.domainList = this.domainList.sort((a, b) => {
        if (this.domainSort === 'asc') {
          return a.domain < b.domain ? -1 : a.domain > b.domain ? 1 : 0
        } else {
          return b.domain < a.domain ? -1 : b.domain > a.domain ? 1 : 0
        }
      })
    },
    sortPath () {
      this.pathSort = !this.pathSort ? 'asc' : this.pathSort === 'asc' ? 'desc' : 'asc'
      this.selectedDomain.firstPathList = this.selectedDomain.firstPathList.sort((a, b) => {
        if (this.pathSort === 'asc') {
          return a < b ? -1 : a > b ? 1 : 0
        } else {
          return b < a ? -1 : b > a ? 1 : 0
        }
      })
    },
    searchPath () {
      this.searchPathList = this.selectedDomain.firstPathList.filter(path => path.match(this.searchPathText))
    },
    selectDomain (domain) {
      if (domain.firstPathList.length === 0) return
      this.searchPathText = ''
      if (domain.firstPathList.length > 1) {
        this.pathSort = 'asc'
      }

      this.selectedDomain = domain
      this.selectedPathList = this.sharedDomains[domain.sid]
    },
    toggleDomain (domain, state = null) {
      domain.isShare = state !== null ? !state : !domain.isShare
      this.sharedDomains[domain.sid] = domain.isShare ? this.domainList.find(item => item === domain).firstPathList.slice() : []
      if (this.selectedDomain && domain.sid === this.selectedDomain.sid) {
        this.selectedPathList = domain.isShare ? this.domainList.find(item => item === domain).firstPathList.slice() : []
      }
      this.updateSharedDomain()
    },
    toggleAllDomain () {
      const state = this.domainListState === 'on'
      this.domainList.forEach(item => {
        this.toggleDomain(item, state)
      })
      this.updateSharedDomain()
    },
    toggleAllPath () {
      if (!this.selectedDomain) return
      const state = this.pathListState === 'on'
      this.selectedDomain.isShare = !state
      this.selectedPathList = state ? [] : [...this.selectedDomain.firstPathList]
      this.sharedDomains[this.selectedDomain.sid] = this.selectedPathList
      this.updateSharedDomain()
    },
    toggleFirstPath (path, i) {
      const pathIndex = this.checkSelectPath(path)
      // pathIndex > -1 ? this.sharedDomains[this.selectedDomain.sid].splice(pathIndex, 1) : this.sharedDomains[this.selectedDomain.sid].push(path)
      if (pathIndex > -1) {
        this.selectedPathList.splice(pathIndex, 1)
        if (this.selectedPathList.length === 0) this.selectedDomain.isShare = false
      } else {
        this.selectedPathList.push(path)
        if (this.selectedPathList.length === 1) this.selectedDomain.isShare = true
      }
      this.sharedDomains[this.selectedDomain.sid] = this.selectedPathList
      this.updateSharedDomain()
    },
    checkSelectPath (path) {
      return this.selectedPathList.findIndex(item => item === path)
      // return this.sharedDomains[this.selectedDomain.sid].findIndex(item => item === path)
    },
    matchedText (text) {
      return text.replace(this.searchPathText, `<span class="match-text">${this.searchPathText}</span>`)
    }
  }
}
</script>

<style lang="scss" scoped>
.step-list-container {
  position: relative;
  display: flex;
  .search-input {
    position: absolute;
    bottom: 100%;
    right: 0;
    margin-bottom: 20px;
    border: 1px solid #bbb;
    border-radius: 6px;
    padding: 8px 10px;
    input {
      border: 0;
      padding: 0;
      width: 250px;
    }
  }
  .step-list {
    position: relative;
    transition: transform 250ms ease;
    flex-grow: 1;
    .step-list-header {
      display: flex;
      align-items: center;
      padding: 10px;
      color: #fff;
      gap: 5px;
      .checkbox-wrap {
        margin-right: 3px;
      }
      .step-badge {
        display: inline-block;
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.30);
        background-color: #fff;
        font-size: 12px;
        color: #444;
        padding: 3px 6px;
        font-weight: 500;
        line-height: 1;
        margin-right: 5px;
      }
      .step-tooltip-button {
        margin-right: 5px;
      }
      .step-sort-btn {
        display: flex;
        flex-direction: column;
        border-radius: 3px;
        background-color: #272727;
        box-shadow: 0 0 0 1px hsla(0, 0%, 100%, .146);
        &.asc i:last-child, &.desc i:first-child {
          opacity: .2;
        }
        &.disabled {
          opacity: .3;
          pointer-events: none;
        }
      }
    }
    .step-list-body {
      position: relative;
      height: calc(43px * 7);
      overflow-y: auto;
      .step-item-row {
        .ste-item {
          font-size: 13px;
          color: #666;
          line-height: 1.2;
          // transform: translateX(-5px);
        }
        &:last-child {
          margin-bottom: 15px;
        }
        &.selected {
          padding: 0;
          margin-left: 5px;
          margin-right: 5px;
          height: 41px;
          border-radius: 5px;
          border: 1px solid $brandColor;
          box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.08);
          .step-item {
            border: 0;
          }
          .step-button {
            box-shadow: none;
            background-color: transparent;
            &:hover {
              background: transparent;
            }
          }
        }
      }
      .no-item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: #2f2f2f;
        font-size: 14px;
      }
      &.onSelect {
        .step-item-row:not(.selected) {
          .step-item {
            background-color: #f1f1f1;
          }
        }
      }
    }
    .step-item-row {
      padding: 0 5px;
      .step-item {
        position: relative;
        cursor: pointer;
        padding: 11.5px 10px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ebebeb;
        gap: 10px;
        .step-title {
          flex-grow: 1;
          font-size: 13px;
          line-height: 1.2;
          &.path-name {
            &:before, &:after {content: '/'}
          }
          &.path-name-none {
            &:before {content: '/'}
          }
        }
        .step-button {
          cursor: pointer;
          position: absolute;
          width: 32px;
          height: 32px;
          top: 50%;
          right: 0;
          transform: translate(-10px, -50%);
          padding: 6px;
          border-radius: 5px;
          box-sizing: border-box;
          background-color: #fff;
          box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.06), 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
          &:hover {
            background-color: rgba(0, 0, 0, 0.06);
          }
        }
      }
    }
    &.base-step-list {
      width: 100%;
      .step-list-header {
        background-color: #375F7B;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        .step-sort-btn {
          background-color: #16374E;
        }
      }
      .step-list-body {
        .step-item-row {
          // &:hover:not(.selected) {
          //   .step-item {
          //     background-color: #f1f1f1;
          //   }
          // }
        }
      }
    }
    &.children-step-list {
      width: 50%;
      overflow: hidden;
      max-width: 50%;
      flex-shrink: 0;
      .step-list-header {
        background-color: #333;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-left: 1px solid transparent;
        padding-left: 15px;
      }
      .step-list-body {
        border-left: 1px solid rgba(0, 0, 0, 0.16);
        .step-item-row {
          padding-left: 15px;
          .step-item {
            padding: 11.5px 0;
          }
        }
      }
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 30px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 35.94%, rgba(255, 255, 255, 0.96) 61.46%, #FFF 100%);
    }
  }
  &:not(.open-child) {
    .base-step-list {
      .step-list-header {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
  }
}

.checkbox-wrap {
  .checkbox {
    cursor: pointer;
    width : 16px;
    height: 16px;
    margin: 1px;
    border: 2px solid #aaa;
    border-radius: 2px;
    background-color: #fff;
    box-sizing: border-box;
    &.on {
      border: 0;
      background: url('../../assets/img/common/icon--check-white-size14.svg') center center no-repeat $brandColor;
    }
    &.set {
      border: 0;
      background: url('../../assets/img/icon_chkbox_on_unselect.svg') center center no-repeat $brandColor;
    }
    &.disabled {
      background: #f4f4f4;
      pointer-events: none;
    }
  }
}
</style>
